<!--<ul class="navbar">
  <li class="nav-item" style="float:left">Danh sách lớp đang theo học</li>
  <li class="nav-item active">
    <a class="nav-link" (click)="save_chondoituong()">
      <i style="color:red" class="fa-2x mr-2 far fa-window-close"></i>
      Thoát
    </a>
  </li>

</ul>-->



<div class="row">
  <div class="col-12">
    <!--<label class="control-label" style="font-weight:bold;color:cornflowerblue">Danh sách lớp đang theo học</label>-->
    <button class="btn btn-info btn-primary" style="float:right;margin-right:6px" (click)="search()">
      <i class="fas fa-search"></i>
      {{'Tìm kiếm' | translate}}
    </button>
  </div>
  
</div>

<!-- lưới chi tiết -->
<div style="padding: 2px 10px 10px 10px;color:black !important; height: calc(100vh - 200px)">
  <div class="row">
    <table id="fixTableQT" class="table table-striped table-bordered table-hover table-condensed">
      <thead>
        <!--<thead>-->
        <tr>
          <th style="width:40px;text-align:center;background-color:#f3f8fc">STT</th>
          <th style="width:50px;text-align:center;background-color:#f3f8fc">{{'Chọn' | translate}}</th>
          <th style="width:100px;text-align:center;background-color:#f3f8fc">Ngày tạo</th>
          <th style="width:100px;text-align:center;background-color:#f3f8fc">Ngày đăng ký</th>
          <th style="width:100px;text-align:center;background-color:#f3f8fc">Khóa học</th>
          <th style="width:110px;text-align:center;background-color:#f3f8fc">Gói phí</th>
          <th style="width:110px;text-align:center;background-color:#f3f8fc">Giảm giá</th>
          <th style="width:110px;text-align:center;background-color:#f3f8fc">Thực thu</th>
          <th style="width:110px;text-align:center;background-color:#f3f8fc">Số buổi</th>
          <th style="width:120px;text-align:center;background-color:#f3f8fc">Loại đăng ký</th>


        </tr>

        

      </thead>
      <tbody style="height:calc(100vh - 260px);">
        <tr *ngFor="let u of datas">
          <td style="width:40px;text-align:center"><a>{{u.STT}}</a></td>
          <td style="text-align:center;width:50px"><input type="checkbox" [(ngModel)]="u.Tich" /></td>
          <td style="width:100px"><a>{{u.Created | date:'dd/MM/yyyy'}}</a></td>
          <td style="width:100px"><a>{{u.NgayDangKy | date:'dd/MM/yyyy'}}</a></td>
          <td style="width:100px"><a>{{u.KhoaHoc}}</a></td>
          <td style="width:110px;color:red;text-align:right">{{u.GiaPhi | number}}</td>
          <td style="width:110px;color:red;text-align:right">{{u.DuocGiam | number}}</td>
          <td style="width:110px;color:red;text-align:right">{{u.ThucThu | number}}</td>
          <td style="width:110px;text-align:center">{{u.SoBuoi}}</td>
          <td style="width:120px">{{u.LoaiDangKy}}</td>

        </tr>
      </tbody>
    </table>


  </div>

</div>





<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div>
    <div *ngIf="totalItems>=10">
      <ul class="pagination">
        <li [ngClass]="{disabled: currentPage === 1}">
          <a (click)="setPage(1)"><<</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(currentPage + 1)">></a>
        </li>
        <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li [ngClass]="{disabled:currentPage === 1}">
          <a (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(totalPages)">>></a>
        </li>
        <li>
          <input type="number" style="width:50px;height:25px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
        </li>
        <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
      </ul>
    </div>
  </div>
  <div class="">
    <button type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">{{'Lưu lại' | translate}}</button>
    <button class="mb-1 mr-1 btn btn-secondary" (click)="save_chondoituong()" title="Ấn ESC để thoát" style="padding-top:0px !important">Đóng lại</button>
  </div>

</div>








